// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__256C7","colBig":"styles_colBig__1hE_y","colSmall":"styles_colSmall__1NEtj","shopifyNameWrapper":"styles_shopifyNameWrapper__3ie1U"};